@if (model != null) {
  <sc-flex stretchContent>
    @for (column of model.columns; track column; let i = $index) {
      @if (i > 0) {
        <sc-content-spacer></sc-content-spacer>
      }
      <sc-flex-fitting-content>
        <sc-flex vertical stretchContent>
          @for (option of column.options; track option; let i = $index) {
            @if (showInternalTransportOptions || option.onlyInternal !== true) {
              @if (i > 0) {
                <sc-content-spacer vertical></sc-content-spacer>
              }
              <app-transport-option-entry [option]="option" [model]="model"
              [showInternalTransportOptions]="showInternalTransportOptions" [showDriverHints]="showDriverHints"></app-transport-option-entry>
            }
          }
        </sc-flex>
      </sc-flex-fitting-content>
    }
  </sc-flex>
  @if (!model.readOnly) {
    @for (message of model.messages; track message) {
      <sc-hint-legacy [dictionaryKey]="message" type="error">
      </sc-hint-legacy>
    }
  }
}
